import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { RefreshCw } from 'lucide-react';
import { wc26Service } from '../../services/api';
import './FinalBracketView.css';

// ─── Bracket FIFA officiel WC2026 (M73 → M104) ─────────────────────────────
// Source : schéma FIFA officiel mis à jour 28/06/2026 (image utilisateur).
// Tous les Round of 32 ont leurs équipes confirmées (groupes terminés).
const R32 = [
  { num: 73, t1: 'Afrique du Sud', t2: 'Canada', date: 'DI 28/06 21:00' },
  { num: 74, t1: 'Allemagne', t2: 'Paraguay', date: 'LU 29/06 22:30' },
  { num: 75, t1: 'Pays-Bas', t2: 'Maroc', date: 'MA 30/06 03:00' },
  { num: 76, t1: 'Brésil', t2: 'Japon', date: 'LU 29/06 19:00' },
  { num: 77, t1: 'France', t2: 'Suède', date: 'LU 29/06 22:30' },
  { num: 78, t1: "Côte d'Ivoire", t2: 'Norvège', date: 'MA 30/06 23:00' },
  { num: 79, t1: 'Mexique', t2: 'Équateur', date: 'ME 01/07 03:00' },
  { num: 80, t1: 'Angleterre', t2: 'RD Congo', date: 'ME 01/07 18:00' },
  { num: 81, t1: 'États-Unis', t2: 'Bosnie-Herzégovine', date: 'JE 02/07 21:00' },
  { num: 82, t1: 'Belgique', t2: 'Sénégal', date: 'JE 02/07 02:00' },
  { num: 83, t1: 'Portugal', t2: 'Croatie', date: 'ME 01/07 22:00' },
  { num: 84, t1: 'Espagne', t2: 'Autriche', date: 'VE 03/07 01:00' },
  { num: 85, t1: 'Suisse', t2: 'Algérie', date: 'VE 03/07 05:00' },
  { num: 86, t1: 'Argentine', t2: 'Cap-Vert', date: 'VE 03/07 20:00' },
  { num: 87, t1: 'Colombie', t2: 'Ghana', date: 'SA 04/07 03:30' },
  { num: 88, t1: 'Australie', t2: 'Égypte', date: 'SA 04/07 00:00' },
];
// 1/8 (M89-M96) — relations EXACTES du bracket officiel FIFA WC2026
const R16 = [
  { num: 89, src: [74, 77], date: 'SA 04/07 23:00' },
  { num: 90, src: [73, 75], date: 'SA 04/07 19:00' },
  { num: 91, src: [76, 78], date: 'LU 06/07 21:00' },
  { num: 92, src: [79, 80], date: 'MA 07/07 18:00' },
  { num: 93, src: [83, 84], date: 'DI 05/07 22:00' },
  { num: 94, src: [81, 82], date: 'DI 05/07 22:00' },
  { num: 95, src: [86, 88], date: 'MA 07/07 21:00' },
  { num: 96, src: [85, 87], date: 'MA 07/07 22:00' },
];
const QUARTS = [
  { num: 97, src: [89, 90], date: 'JE 09/07 22:00' },
  { num: 98, src: [93, 94], date: 'DI 12/07 03:00' },
  { num: 99, src: [91, 92], date: 'VE 10/07 21:00' },
  { num: 100, src: [95, 96], date: 'SA 11/07 23:00' },
];
const DEMIS = [
  { num: 101, src: [97, 98], date: 'MA 14/07 21:00' },
  { num: 102, src: [99, 100], date: 'ME 15/07 21:00' },
];
const FINALE = { num: 104, src: [101, 102], date: 'DI 19/07 21:00 · New York/New Jersey' };

// Drapeaux emoji (fallback simple)
const FLAGS = {
  'Mexique':'🇲🇽','Afrique du Sud':'🇿🇦','Suisse':'🇨🇭','Canada':'🇨🇦','Brésil':'🇧🇷','Maroc':'🇲🇦',
  'Belgique':'🇧🇪','Égypte':'🇪🇬','Allemagne':'🇩🇪','Paraguay':'🇵🇾','Argentine':'🇦🇷','Algérie':'🇩🇿',
  'France':'🇫🇷','Suède':'🇸🇪','Pays-Bas':'🇳🇱','Italie':'🇮🇹','Croatie':'🇭🇷','États-Unis':'🇺🇸',
  'Bosnie-Herzégovine':'🇧🇦','Espagne':'🇪🇸','Uruguay':'🇺🇾','Cap-Vert':'🇨🇻','Portugal':'🇵🇹','Japon':'🇯🇵',
  "Côte d'Ivoire":'🇨🇮','Norvège':'🇳🇴','Sénégal':'🇸🇳','Angleterre':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Australie':'🇦🇺',
  'Ghana':'🇬🇭','Équateur':'🇪🇨','RD Congo':'🇨🇩','Colombie':'🇨🇴','Autriche':'🇦🇹','Iran':'🇮🇷',
  'Tchéquie':'🇨🇿','Pays de Galles':'🏴󠁧󠁢󠁷󠁬󠁳󠁿','Écosse':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Tunisie':'🇹🇳','Turquie':'🇹🇷','Corée du Sud':'🇰🇷',
  'Arabie saoudite':'🇸🇦','Jordanie':'🇯🇴','Irak':'🇮🇶','Cameroun':'🇨🇲','Nigeria':'🇳🇬','Mali':'🇲🇱',
  'Ouzbékistan':'🇺🇿','Ouganda':'🇺🇬','Qatar':'🇶🇦','Nouvelle-Zélande':'🇳🇿','Costa Rica':'🇨🇷','Panama':'🇵🇦',
};
const flag = (name) => FLAGS[name] || '🏳️';

// ─── Composant carte de match ───────────────────────────────────────────────
const MatchCard = ({ num, team1, team2, date, round, vs1Label, vs2Label }) => {
  const renderSide = (team, vsLabel, side) => {
    if (team.name) {
      return (
        <div className="flex items-center gap-1.5 justify-end" data-testid={`bracket-${side}-${num}`}>
          <span className="text-base leading-none">{flag(team.name)}</span>
          <span className="font-semibold text-zinc-900 text-[11px] leading-tight">{team.name}</span>
        </div>
      );
    }
    // Placeholder : même taille que les vrais noms, italique gris pour distinguer
    return (
      <div className="flex items-center justify-end" data-testid={`bracket-${side}-${num}`}>
        <span className="italic text-zinc-500 text-[11px] leading-tight">{vsLabel || team.fallback}</span>
      </div>
    );
  };
  return (
    <div className="bracket-match flex items-stretch bg-white rounded-md overflow-hidden shadow-md border border-zinc-200 min-w-[200px]">
      <div className="flex flex-col items-center justify-center bg-green-700 text-white font-bold px-2 py-2 min-w-[36px] text-sm">
        {num}
      </div>
      <div className="flex-1 px-2 py-1.5 flex flex-col gap-0.5">
        {round && <div className="text-[9px] text-zinc-500 font-semibold uppercase">{round}</div>}
        {renderSide(team1, vs1Label, 'team1')}
        <div className="text-[9px] text-zinc-400 font-bold text-center leading-none my-0.5">vs</div>
        {renderSide(team2, vs2Label, 'team2')}
        {date && <div className="text-[8px] text-zinc-500 mt-0.5 text-center">{date}</div>}
      </div>
    </div>
  );
};

const FinalBracketView = () => {
  const [resolved, setResolved] = useState({});       // 1A → Mexique
  const [matchLookup, setMatchLookup] = useState({}); // {date_iso: [fixtures]}
  const [refreshing, setRefreshing] = useState(false);
  const [hideR32, setHideR32] = useState(false);      // 🆕 Toggle 1/16

  const loadAll = useCallback(async () => {
    try {
      const [r, l] = await Promise.all([
        wc26Service.getResolvedTeams(),
        wc26Service.getMatchLookup(),
      ]);
      setResolved(r?.resolved || {});
      setMatchLookup(l?.by_date || {});
    } catch { /* ignore */ }
  }, []);

  useEffect(() => { loadAll(); }, [loadAll]);

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await wc26Service.refresh();
      await loadAll();
    } finally { setRefreshing(false); }
  };

  // Résolution d'un slot : "1A" → "Mexique", "3C/E/F/H/I" → placeholder
  const resolveSlot = (slotCode) => {
    if (!slotCode) return { name: null, fallback: '?' };
    if (slotCode.includes('/')) {
      const m = slotCode[0];
      const rest = slotCode.slice(1);
      return { name: null, fallback: `${m}ème ${rest}` };
    }
    const team = resolved[slotCode];
    if (team) return { name: team };
    return { name: null, fallback: `${slotCode[0]}er ${slotCode.slice(1)}` };
  };

  // Pour les knockout : trouve la fixture API par timestamp (M73 par ex.)
  // Plus simple : utilise resolveSlot car les vraies équipes sont déjà dans
  // resolved-teams via standings. Pour M73 = 2A vs 2B, on a 2A et 2B résolus.

  // 🆕 Vainqueurs DÉTECTÉS AUTOMATIQUEMENT depuis api-football (status=FT + scores).
  // On matche les fixtures knockout par {home, away} == {t1, t2} de chaque match R32/R16/...
  // is_finished + scores → on déduit le vainqueur sans rien hardcoder.
  const CONFIRMED_WINNERS = useMemo(() => {
    const out = {};
    const allFixtures = Object.values(matchLookup || {}).flat();
    if (allFixtures.length === 0) return out;

    const norm = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const sameTeams = (fx, ta, tb) => {
      const fh = norm(fx.home);
      const fa = norm(fx.away);
      const na = norm(ta);
      const nb = norm(tb);
      // Match exact OU contient (Bosnie-Herzégovine vs Bosnia and Herzegovina etc.)
      const m1 = (fh === na || fh.includes(na) || na.includes(fh)) && (fa === nb || fa.includes(nb) || nb.includes(fa));
      const m2 = (fh === nb || fh.includes(nb) || nb.includes(fh)) && (fa === na || fa.includes(na) || na.includes(fa));
      return m1 || m2;
    };
    const winnerOf = (fx) => {
      if (!fx.is_finished) return null;
      // PRIORITÉ : flag officiel api-football (gère prolongation + TAB)
      if (fx.home_winner === true) return fx.home;
      if (fx.away_winner === true) return fx.away;
      // FALLBACK : score temps réglementaire
      const hg = fx.home_goals, ag = fx.away_goals;
      if (typeof hg !== 'number' || typeof ag !== 'number') return null;
      if (hg > ag) return fx.home;
      if (ag > hg) return fx.away;
      return null; // égalité sans flag winner : on attend la mise à jour API
    };

    // R32 : on a les 2 équipes confirmées → on cherche la fixture correspondante
    R32.forEach(m => {
      const fx = allFixtures.find(f => sameTeams(f, m.t1, m.t2) && (f.round === 'Round of 32' || f.round === 'Round of 16'));
      if (fx) {
        const w = winnerOf(fx);
        if (w) out[m.num] = w;
      }
    });
    // R16 (1/8) : on connaît le vainqueur des 2 R32 sources → on peut matcher
    R16.forEach(m => {
      const w1 = out[m.src[0]];
      const w2 = out[m.src[1]];
      if (!w1 || !w2) return;
      const fx = allFixtures.find(f => sameTeams(f, w1, w2));
      if (fx) {
        const w = winnerOf(fx);
        if (w) out[m.num] = w;
      }
    });
    // Quarts : pareil
    QUARTS.forEach(m => {
      const w1 = out[m.src[0]];
      const w2 = out[m.src[1]];
      if (!w1 || !w2) return;
      const fx = allFixtures.find(f => sameTeams(f, w1, w2));
      if (fx) {
        const w = winnerOf(fx);
        if (w) out[m.num] = w;
      }
    });
    // Demis : pareil
    DEMIS.forEach(m => {
      const w1 = out[m.src[0]];
      const w2 = out[m.src[1]];
      if (!w1 || !w2) return;
      const fx = allFixtures.find(f => sameTeams(f, w1, w2));
      if (fx) {
        const w = winnerOf(fx);
        if (w) out[m.num] = w;
      }
    });
    return out;
  }, [matchLookup]);

  // Récupère le label "haut" et "bas" d'une carte de round avancé.
  // Si vainqueur confirmé → retourne le nom de l'équipe résolue.
  // Sinon → retourne la paire "TeamA/TeamB" (équipes des 2 R32 sources).
  const getAdvancedSide = (srcMatchNum) => {
    if (CONFIRMED_WINNERS[srcMatchNum]) {
      return { name: CONFIRMED_WINNERS[srcMatchNum] };
    }
    // Cherche les 2 équipes possibles du match source
    const r32 = R32.find(x => x.num === srcMatchNum);
    if (r32) return { name: null, fallback: `${r32.t1}/${r32.t2}` };
    const r16 = R16.find(x => x.num === srcMatchNum);
    if (r16) {
      const a = R32.find(x => x.num === r16.src[0]);
      const b = R32.find(x => x.num === r16.src[1]);
      const aLbl = CONFIRMED_WINNERS[r16.src[0]] || (a ? `${a.t1}/${a.t2}` : `?`);
      const bLbl = CONFIRMED_WINNERS[r16.src[1]] || (b ? `${b.t1}/${b.t2}` : `?`);
      return { name: null, fallback: `(${aLbl}) / (${bLbl})` };
    }
    return { name: null, fallback: `vainqueur ${srcMatchNum}` };
  };

  const renderR32 = (num) => {
    const m = R32.find(x => x.num === num);
    if (!m) return null;
    return <MatchCard key={num} num={num} round="1/16" date={m.date}
      team1={{ name: m.t1 }} team2={{ name: m.t2 }} isKnockout />;
  };
  const renderR16 = (num) => {
    const m = R16.find(x => x.num === num);
    if (!m) return null;
    const s1 = getAdvancedSide(m.src[0]);
    const s2 = getAdvancedSide(m.src[1]);
    return <MatchCard key={num} num={num} round="1/8" date={m.date}
      team1={s1} team2={s2} />;
  };
  const renderQuart = (num) => {
    const m = QUARTS.find(x => x.num === num);
    if (!m) return null;
    const s1 = getAdvancedSide(m.src[0]);
    const s2 = getAdvancedSide(m.src[1]);
    return <MatchCard key={num} num={num} round="QUART" date={m.date}
      team1={s1} team2={s2} />;
  };
  const renderDemi = (num) => {
    const m = DEMIS.find(x => x.num === num);
    if (!m) return null;
    return <MatchCard key={num} num={num} round="DEMI" date={m.date}
      team1={{ name: null, fallback: '' }} team2={{ name: null, fallback: '' }}
      vs1Label={`vainqueur ${m.src[0]}`} vs2Label={`vainqueur ${m.src[1]}`} />;
  };

  return (
    <div className="space-y-4" data-testid="final-bracket-view">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold text-amber-400 tracking-wide">🏆 COUPE DU MONDE 2026 — TABLEAU FINAL</h2>
        <div className="flex items-center gap-2">
          <Button
            onClick={() => setHideR32(v => !v)}
            variant="outline"
            size="sm"
            data-testid="bracket-toggle-r32"
            title={hideR32 ? 'Afficher les 1/16' : 'Masquer les 1/16 (agrandit le bracket)'}
          >
            {hideR32 ? '👁️ Afficher 1/16' : '🗂️ Masquer 1/16'}
          </Button>
          <Button onClick={handleRefresh} variant="outline" size="sm" disabled={refreshing} data-testid="bracket-refresh">
            <RefreshCw className={`h-4 w-4 mr-2 ${refreshing ? 'animate-spin' : ''}`}/>Sync
          </Button>
        </div>
      </div>
      <Card className="bg-zinc-950 border-zinc-800">
        <CardContent className="p-4 wc-bracket-wrap">
          <div className="wc-bracket" data-testid="bracket-grid" style={{ minWidth: hideR32 ? '1400px' : '1700px' }}>
            {/* Col 1 : R32 gauche (8 matches) */}
            {!hideR32 && (
              <div className="wc-col wc-r32 wc-left">
                {[74, 77, 73, 75, 81, 82, 83, 84].map(n => (
                  <div key={n} className="wc-match">{renderR32(n)}</div>
                ))}
              </div>
            )}
            {/* Col 2 : R16 gauche (4 matches) */}
            <div className="wc-col wc-r16 wc-left">
              {[89, 90, 94, 93].map(n => (
                <div key={n} className="wc-match">{renderR16(n)}</div>
              ))}
            </div>
            {/* Col 3 : Quarts gauche (2 matches) */}
            <div className="wc-col wc-qf wc-left">
              {[97, 98].map(n => (
                <div key={n} className="wc-match">{renderQuart(n)}</div>
              ))}
            </div>
            {/* Col 4 : Demi gauche (1 match) */}
            <div className="wc-col wc-sf wc-left">
              <div className="wc-match">{renderDemi(101)}</div>
            </div>
            {/* Col 5 : Centre (Logo + Finale) */}
            <div className="wc-col-center">
              <div className="text-4xl font-black text-amber-400 leading-none text-center">20<br/>26</div>
              <div className="text-3xl">🏆</div>
              <div className="wc-finale-block">
                <MatchCard num={FINALE.num} round="FINALE" date={FINALE.date}
                  team1={{ name: null, fallback: '' }} team2={{ name: null, fallback: '' }}
                  vs1Label={`vainqueur ${FINALE.src[0]}`} vs2Label={`vainqueur ${FINALE.src[1]}`} />
              </div>
            </div>
            {/* Col 6 : Demi droite (1 match) */}
            <div className="wc-col wc-sf wc-right">
              <div className="wc-match">{renderDemi(102)}</div>
            </div>
            {/* Col 7 : Quarts droite (2 matches) */}
            <div className="wc-col wc-qf wc-right">
              {[99, 100].map(n => (
                <div key={n} className="wc-match">{renderQuart(n)}</div>
              ))}
            </div>
            {/* Col 8 : R16 droite (4 matches) */}
            <div className="wc-col wc-r16 wc-right">
              {[91, 92, 95, 96].map(n => (
                <div key={n} className="wc-match">{renderR16(n)}</div>
              ))}
            </div>
            {/* Col 9 : R32 droite (8 matches) */}
            {!hideR32 && (
              <div className="wc-col wc-r32 wc-right">
                {[76, 78, 79, 80, 86, 88, 85, 87].map(n => (
                  <div key={n} className="wc-match">{renderR32(n)}</div>
                ))}
              </div>
            )}
          </div>
        </CardContent>
      </Card>
      <div className="text-xs text-zinc-500 italic text-center">
        ● Équipes en vert = qualifiées (1er/2e de groupe terminé) &nbsp;|&nbsp; ● Placeholders italique = à déterminer (FIFA) &nbsp;|&nbsp; Données api-football live + bracket FIFA officiel
      </div>
    </div>
  );
};

export default FinalBracketView;
